import React from 'react';
import { escape } from 'lodash';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { useConfig } from './config-context';
var placeholderWithFormatters = /\${[a-z0-9&_.[\]:;-|]{1,256}}/gi;
export function BdiWrapper(_a) {
    var text = _a.text;
    var wrapPlaceholders = useConfig().wrapPlaceholders;
    if (!wrapPlaceholders) {
        return React.createElement(React.Fragment, null, text);
    }
    var wrappedText = escape(text || '').replace(placeholderWithFormatters, function (match) {
        return '<bdi>' + match + '</bdi>';
    });
    return React.createElement(SecureHtml, { html: wrappedText, as: "span" });
}
//# sourceMappingURL=bdi-wrapper.js.map